import { createRoutine } from 'redux-saga-routines';
export const detectMarket = createRoutine('@shared/detect-market');
